import styled from '@emotion/styled';
import { LIGHT_BLUE, GREY, APP_TEMA, WHITE, BEI_JYO } from '../../styles/color';

export const DataIkoLayout = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
  border-radius: 10px;
  width: 100%;
  text-align: center;
  padding-bottom: 100px;
`;

export const DataIkoBody = styled.div`
  max-width: 800px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 20px;
  
  @media (max-width: 768px) {
    padding: 0 10px;
  }
`;

export const Title = styled.h2`
  margin-left: 20px;
  margin-right: 20px;
  color: ${LIGHT_BLUE};
  text-align: left;
  margin-bottom: 20px;
`;

export const StyledCard = styled.div`
  background-color: ${WHITE};
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 20px;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  background-color: ${APP_TEMA};
  color: ${WHITE};
  padding: 12px 15px;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CardBody = styled.div`
  padding: 20px;
  background-color: ${BEI_JYO};
`;

export const FormControl = styled.input`
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid ${GREY};
  border-radius: 4px;
  
  &:focus {
    outline: none;
    border-color: ${LIGHT_BLUE};
    box-shadow: 0 0 0 2px rgba(0, 149, 255, 0.2);
  }
`;

export const Label = styled.label`
  display: block;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 6px;
  color: #333;
`;

export const FormRow = styled.div`
  margin-bottom: 16px;
`;

export const ExecuteButton = styled.button`
  padding: 10px 30px;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: ${LIGHT_BLUE};
  color: ${WHITE};
  font-weight: bold;
  
  &:hover {
    background-color: #007ACC;
  }
  
  &:disabled {
    background-color: ${GREY};
    cursor: not-allowed;
  }
`;

export const Instructions = styled.ul`
  text-align: left;
  padding-left: 20px;
  
  li {
    margin-bottom: 8px;
    line-height: 1.5;
  }
`;

export const WarningText = styled.p`
  color: #e33737;
  font-size: 13px;
  font-weight: bold;
  text-align: left;
  margin-bottom: 16px;
`;
